import api from './auth.api';
import type { SubscriberPaymentOrder, PaginationInfo } from './subscribers.api';

export interface PendingPaymentApproval {
  paymentOrder: SubscriberPaymentOrder;
  subscriber: {
    id: number;
    fullname: string | null;
    subscriberCode: string | null;
    phone: string | null;
    crmSubscriberId: number;
  };
  site: {
    name: string | null;
    crmSiteId: number | null;
  };
}

export interface PendingApprovalsResponse {
  approvals: PendingPaymentApproval[];
  pagination: PaginationInfo;
}

export const approvalsApi = {
  listPending: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<PendingApprovalsResponse> => {
    const response = await api.get<{ success: boolean; data: PendingApprovalsResponse }>(
      '/subscribers/payment-orders/pending-approvals',
      { params }
    );
    return response.data.data;
  },
};
